
<div class="cases">
  <v-divider color="#D7D7D7"></v-divider>
  <div class="custom-control custom-checkbox mb-4 d-flex align-items-center">
    <input type="checkbox" v-model="localAddToCase" class="custom-control-input mr-1" id="case"
      @change="toggleSelection" />
    <label class="custom-control-label" for="case">Also add it to the case</label>
  </div>
  <div v-if="localAddToCase" class="px-2 py-0 position-relative">
    <label class="mb-0 c-label mb-2" style="font-size: 14px;">Select Case</label>
    <v-autocomplete ref="autocomplete" :loading="casesLoading" solo dense flat hide-details label="Select Case"
      class="gray-2-placeholder gray-2-border" :items="cases" item-text="name" item-value="id"
      v-model="localSelectedCase" :search-input.sync="searchQuery" @change="handleSelectChange">
      <template v-slot:item="{ item }">
        <div>{{ item.name ? item.name : '-' }}</div>
      </template>
      <template v-slot:append-item>
        <div v-if="!allCasesLoaded" ref="loadMore" v-intersect="onIntersect" class="pa-4 text-primary"
          style="font-style: italic;">
          Loading more cases...
        </div>
      </template>
    </v-autocomplete>
  </div>
</div>
